import{number,string,shape}from'prop-types';export var professionalServicePropTypes=shape({name:string,price:number,description:string});